import Separator from 'components/common/separator';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import FlightRescheduleItemCard from './card';
import { FlightRescheduleFormType } from '../form-type';

export default function FlightItems() {
  const { control } = useFormContext<FlightRescheduleFormType>();
  const { fields } = useFieldArray({
    control,
    name: 'flightSales',
    keyName: 'customId',
  });

  return (
    <>
      {fields.map((field, idx) => (
        <React.Fragment key={field.customId}>
          <FlightRescheduleItemCard parentIndex={idx} />
          <Separator gap={16} />
        </React.Fragment>
      ))}
    </>
  );
}
